export { default } from './PreferenceIntroWithImageStep';
